import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TOGGLES } from '@eggplant/api-hosts'
import {
  createContext,
  useState
} from 'react'
import type { ReactNode } from 'react'
import type { TogglesResponse } from '@eggplant/types'

interface CustomScriptProps {
  isCustomScriptEnabled?: boolean
}

export const CustomScriptContext = createContext<CustomScriptProps | undefined>(undefined)

interface ProviderProps {
  children: ReactNode
  isCustomScriptEnabled?: boolean
}

export const CustomScriptContextProvider = ({
  children,
  isCustomScriptEnabled: isCustomScriptEnabledProp
}: ProviderProps) => {
  const [isCustomScriptEnabled, setIsCustomScriptEnabled] = useState<boolean>(!!isCustomScriptEnabledProp)

  const handleSuccess = ({ runtime_flags }: TogglesResponse) => {
    setIsCustomScriptEnabled(runtime_flags.ENABLE_CUSTOM_SCRIPTS)
  }

  const handleError = () => {
    setIsCustomScriptEnabled(false)
  }

  const value = { isCustomScriptEnabled }

  return (
    <AuthenticatedDataRequest
      method='get'
      onError={handleError}
      onSuccess={handleSuccess}
      url={TOGGLES + '/toggles'}
    >
      {
        () =>
          <CustomScriptContext.Provider value={value}>
            {children}
          </CustomScriptContext.Provider>
      }
    </AuthenticatedDataRequest>
  )
}

interface ConsumerProps {
  children: (context: CustomScriptProps) => React.ReactNode
}

export const CustomScriptContextConsumer = ({
  children: renderChildren
}: ConsumerProps) =>
  <CustomScriptContext.Consumer>
    {
      (context?: CustomScriptProps) => {
        if (context === undefined) {
          throw new Error('<CustomScriptContextConsumer /> must be used within <CustomScriptContextProvider />')
        }

        return renderChildren(context)
      }
    }
  </CustomScriptContext.Consumer>
